__turbopack_context__.v({
  "activePanel": "designGuide-module__Ui7B1G__activePanel",
  "activeTab": "designGuide-module__Ui7B1G__activeTab",
  "arrow": "designGuide-module__Ui7B1G__arrow",
  "copy": "designGuide-module__Ui7B1G__copy",
  "dao": "designGuide-module__Ui7B1G__dao",
  "guideRow": "designGuide-module__Ui7B1G__guideRow",
  "heroImage": "designGuide-module__Ui7B1G__heroImage",
  "imageWrap": "designGuide-module__Ui7B1G__imageWrap",
  "page": "designGuide-module__Ui7B1G__page",
  "panel": "designGuide-module__Ui7B1G__panel",
  "panels": "designGuide-module__Ui7B1G__panels",
  "tabs": "designGuide-module__Ui7B1G__tabs",
});
